module.exports = __webpack_public_path__ + "media/images/logo-2d94b2e96eae6d5a15e2ab551e3cda68.png";